import React, { useEffect, useState, useRef } from "react";
import { CSVLink } from "react-csv";
import api from "../../services/api";
import { useNavigate } from "react-router";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import Paginator from "../../shared/Paginator";
import config from "../../config";
import {
  formatDate,
} from "../../utils/dateFormat";
import { roles } from "../../utils/constants";
import { SlIconButton } from "@shoelace-style/shoelace/dist/react";

function LineitemDateWise(props) {
  const navigate = useNavigate();
  const [completeData, setCompleteData] = useState([])
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const csvLinkRef = useRef(); // Create a ref for CSVLink
  let csvHeaders = [
    { label: "Date", key: "date" },
    ];
    if (
      localStorage.getItem("role") === roles.ops
    ) {
        csvHeaders.push({ label: "Adv Impressions", key: "adv_total_imp" });
        csvHeaders.push({ label: "Adv Clicks", key: "adv_total_click" });
        csvHeaders.push({ label: "Adv Spent", key: "adv_spent" });
        csvHeaders.push({ label: "Adv CTR(%)", key: "adv_ctr" });
        csvHeaders.push({ label: "Adv ECPM/CPD", key: "adv_ecpm" });
      
    }
    csvHeaders = csvHeaders.concat([{ label: "Impressions", key: "impressions" },
      { label: "Clicks", key: "clicks" },
      { label: "Spent", key: "total_spent" }])
    if (
      localStorage.getItem("role") === roles.ops
    ) {
        csvHeaders.push({ label: "CTR(%)", key: "ctr_percent" });
        csvHeaders.push({ label: "ECPM/CPD", key: "ecpm_cpd" });
        csvHeaders.push({ label: "Enc Impressions", key: "encrypt_imp" });
        csvHeaders.push({ label: "Adv Enc Impressions", key: "encrypt_adv_imp" });
        csvHeaders.push({ label: "Shares", key: "shares" });
    }

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
    setData(completeData.slice(event.selected * config.PER_PAGE,event.selected * config.PER_PAGE + config.PER_PAGE ))
  };

  const getdata = async (page = 0) => {
    setLoader(true);
    try {
      let res = await api({
        url: "/lineitems/lineitemResports",
        method: "POST",
        responseType: "json",
        data: {
          campaign_id: props.campaign_id,
          action: "daywise",
          status:props.status
        },
      });
      if (res.code === 200) {
        setCompleteData(res?.data?.totalres || []);
        setData(res?.data?.totalres.slice(0,config.PER_PAGE) || [])
        setTotalPages(Math.ceil(res?.data?.total / config.PER_PAGE) || 0);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };
  useEffect(() => {
    getdata();
  }, []);
  return (
    <div>
      <div className="d-flex justify-end  pr-4">
      <CSVLink
          data={completeData?.map(
              (item) => {
                  let obj = {
                      date: formatDate(item._id),
                      impressions: item?.total_imp,
                      clicks: item?.total_click,
                      total_spent: item?.total_spent
                  };
                  if (
                    localStorage.getItem("role") === roles.ops
                  ) {
                      obj.shares = item?.shares;
                      obj.ctr_percent =  item ? item?.total_click > 0 && item?.total_imp > 0
                        ? (
                            (item?.total_click / item?.total_imp) *
                            100
                          ).toFixed(2)
                        : 0 : 0;
                      obj.ecpm_cpd = item ? ((item?.total_spent / item?.total_imp) * 1000).toFixed(2) : 0;
                      obj.adv_ctr =  item ? item?.adv_total_click > 0 && item?.adv_total_imp > 0
                        ? (
                            (item?.adv_total_click / item?.adv_total_imp) *
                            100
                          ).toFixed(2)
                        : 0 : 0;
                      obj.adv_ecpm = item ? ((item?.adv_spent / item?.adv_total_imp) * 1000).toFixed(2) : 0;
                      obj.adv_total_imp = item?.adv_total_imp
                      obj.adv_total_click = item?.adv_total_click
                      obj.adv_spent = item?.adv_spent
                      obj.encrypt_imp = item ? parseInt(
                        item?.encrypt_imp > 0 ? item?.encrypt_imp : 0
                      ) : 0
                      obj.encrypt_adv_imp = item ? parseInt(
                        item?.encrypt_adv_imp > 0 ? item?.encrypt_adv_imp : 0
                      ) : 0
                      obj.shares = item ? parseInt(item?.shares > 0 ? item?.shares : 0) : 0
                  }
                  return obj;
              }
          ) || []}
          headers={csvHeaders}
          filename={`${props.campaign_name}_Date_wise.csv`}
          ref={csvLinkRef} // Assign the ref to the CSVLink component
      ></CSVLink>
      <SlIconButton
          library="lucide"
          name="download"
          onClick={() => {
            csvLinkRef?.current?.link?.click();
          }}
      ></SlIconButton>
      </div>
      <div className="overflow-x-auto mb-4">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th scope="col">Date</th>
              {localStorage.getItem("role") === roles.ops && (
                  <th scope="col">Adv Impressions</th>
                )}
              {localStorage.getItem("role") === roles.ops && (
                  <th scope="col">Adv Clicks</th>
                )}
              {localStorage.getItem("role") === roles.ops && (
                  <th scope="col">Adv CTR(%)</th>
                )}
              {localStorage.getItem("role") === roles.ops && (
                  <th scope="col">Adv ECPM</th>
                )}
              <th scope="col">Impressions</th>

              <th scope="col">Clicks</th>
              {localStorage.getItem("role") === roles.ops && (
                  <th scope="col">CTR(%)</th>
                )}
              {localStorage.getItem("role") === roles.ops && (
                  <th scope="col">ECPM</th>
                )}
                {localStorage.getItem("role") === roles.ops && (
                    <th scope="col">Advertiser Spent</th>
                  )}
              <th scope="col">Spent</th>
              {localStorage.getItem("role") === roles.ops && (
                <th>E Adv Impressions</th>
              )}
              {localStorage.getItem("role") === roles.ops && (
                <th>E Impressions</th>
              )}
              {localStorage.getItem("role") === roles.ops && (
                <th>Actual Clicks</th>
              )}
              {localStorage.getItem("role") === roles.ops && <th>Shares</th>}
            </tr>
          </thead>
          {data?.length && !loader ? (
            <tbody>
              {data?.map((item, index) => {
                return (
                  <tr key={item._id}>
                    <td>{formatDate(item._id)}</td>

                    {localStorage.getItem("role") === roles.ops && (
                        <td>{parseInt(item.adv_total_imp)}</td>
                      )}
                    {localStorage.getItem("role") === roles.ops && (
                        <td>{parseInt(item.adv_total_click)}</td>
                      )}
                    {localStorage.getItem("role") === roles.ops && (
                        <td>
                          {item.adv_total_click > 0 && item.adv_total_imp > 0
                            ? (
                                (item.adv_total_click / item.adv_total_imp) *
                                100
                              ).toFixed(2)
                            : 0}
                        </td>
                      )}
                    {localStorage.getItem("role") === roles.ops && (
                        <td>
                          {item ? ((item?.adv_spent / item?.adv_total_imp) * 1000).toFixed(2) : 0}
                        </td>
                      )}
                    <td> {parseInt(item.total_imp)} </td>
                    <td>{parseInt(item.total_click)}</td>

                    {localStorage.getItem("role") === roles.ops && (
                        <td>
                          {item.total_click > 0 && item.total_imp > 0
                            ? (
                                (item.total_click / item.total_imp) *
                                100
                              ).toFixed(2)
                            : 0}
                        </td>
                      )}
                    {localStorage.getItem("role") === roles.ops && (
                        <td>
                          {item ? ((item?.total_spent / item?.total_imp) * 1000)?.toFixed(2) : 0}
                        </td>
                      )}
                    {localStorage.getItem("role") === roles.ops && (
                        <td>
                          {(item.adv_spent)?.toFixed(2)}
                        </td>
                      )}
                    <td>{(item.total_spent)?.toFixed(2)}</td>
                    {localStorage.getItem("role") === roles.ops && (
                      <td className="p-2">
                        {parseInt(
                          item?.encrypt_adv_imp > 0 ? item?.encrypt_adv_imp : 0
                        )}
                      </td>
                    )}
                    {localStorage.getItem("role") === roles.ops && (
                      <td className="p-2">
                        {parseInt(
                          item?.encrypt_imp > 0 ? item?.encrypt_imp : 0
                        )}
                      </td>
                    )}
                    {localStorage.getItem("role") === roles.ops && (
                      <td className="p-2">
                        {parseInt(
                          item?.actual_clicks > 0 ? item?.actual_clicks : 0
                        )}
                      </td>
                    )}
                    {localStorage.getItem("role") === roles.ops && (
                      <td className="p-2">
                        {parseInt(item?.shares > 0 ? item?.shares : 0)}
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          ) : !data?.length && !loader ? (
            <NoDataFound colspan="15" />
          ) : (
            <TableLoader colspan="15" />
          )}
        </table>
      </div>
      <div>
        {totalPages > 1 && (
          <Paginator
            pageCount={totalPages}
            handlePageClick={handlePageClick}
            forcePage={currentPage}
          />
        )}
      </div>
    </div>
  );
}

export default LineitemDateWise;

